import { createFileRoute, Outlet } from '@tanstack/react-router';
import type { ReactNode } from 'react';

/** Layout-only parent for `/articles/$slug` and `/articles/$slug/edit`.
 *
 *  TanStack file-routing nests `articles.$slug.edit.tsx` under
 *  `articles.$slug.tsx` automatically — but the reader (index) and the
 *  writer (edit) are mutually-exclusive screens, NOT a master-detail
 *  pair. If this file rendered the reader directly, the writer route
 *  would mount but never paint (no `<Outlet />` slot for it).
 *
 *  So this file is a transparent passthrough: it only exposes the
 *  `<Outlet />` for child routes. The reader lives in
 *  `articles.$slug.index.tsx`, the writer in `articles.$slug.edit.tsx`. */
function ArticlesSlugLayout(): ReactNode {
  return <Outlet />;
}

export const Route = createFileRoute('/articles/$slug')({
  component: ArticlesSlugLayout,
});
